<template>
  <div>
    <div v-if="loading" class="text-center bg-gray-200 p-4 rounded">
      <Loader />
    </div>

    <div v-else-if="campaigns.length" class="list list-spaced rounded">
      <CampaignLine
        v-for="line in campaigns"
        :key="line.id"
        :campaign="line"
        @campaign-edit="editCampaign"
        @campaign-delete="confirmDeleteCampaign"
      />
    </div>

    <div v-else class="bg-gray-200 p-6 text-center rounded">No campaigns found.</div>

    <template v-if="$membershipHasPermissionTo('edit campaigns')">
      <portal v-if="campaign && isActionEdit" to="app-dialog">
        <CampaignModal :campaign-id="campaign.id" @campaign-modal-close="resetAction" />
      </portal>
    </template>

    <template v-if="$membershipHasPermissionTo('edit projects')">
      <portal v-if="campaign && isActionDelete" to="app-dialog">
        <BaseDialogDelete
          danger
          :custom-classes="'max-w-md'"
          @closed="resetAction"
          @confirmed="$emit('campaign-delete', campaign.id)"
        />
      </portal>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import CampaignModal from '@/components/Campaigns/CampaignModal.vue';
import CampaignLine from './CampaignLine.vue';

const ACTION_EDIT = 'edit';
const ACTION_DELETE = 'delete';

export default {
  components: {
    CampaignLine,
    CampaignModal,
  },

  props: {
    loading: Boolean,
    projectUuid: { type: String, required: true },
    campaigns: { type: Array, default: () => [] },
  },

  data: () => ({
    pending: false,
    action: null,
  }),

  computed: {
    ...mapGetters('ui/campaigns', ['campaign']),

    isActionEdit() {
      return this.action === ACTION_EDIT;
    },

    isActionDelete() {
      return this.action === ACTION_DELETE;
    },
  },

  methods: {
    ...mapMutations('ui/campaigns', ['setCurrent']),

    editCampaign(campaign) {
      this.setCurrent(campaign.id);
      this.action = ACTION_EDIT;
    },

    confirmDeleteCampaign(campaign) {
      this.setCurrent(campaign.id);
      this.action = ACTION_DELETE;
    },

    resetAction() {
      this.setCurrent(null);
      this.action = null;
    },
  },
};
</script>
